import { BudgetPhases } from 'business/constants';
import {
    BUDGET_LINE_STATUS_ARBITRATED,
    BUDGET_LINE_STATUS_TODO,
    BUDGET_LINE_STATUS_TO_ARBITRATE,
    SUPPLEMENTARY_BUDGET,
    SUPPLEMENTARY_BUDGET_AMOUNT,
    SUPPLEMENTARY_BUDGET_COMMENT,
    SUPPLEMENTARY_BUDGET_ENDPOINT,
    SUPPLEMENTARY_BUDGET_ID,
    SUPPLEMENTARY_BUDGET_STATUS,
} from 'routes/BudgetModule/config/constants';
import { StatusesSettingsT } from 'routes/BudgetModule/config/types';
import { isInscriptionRejectedForSupplementary } from 'routes/BudgetModule/helpers/statusHelpers';
import { InscriptionT } from 'routes/BudgetModule/shared/entities/inscription';
import { PhaseHelpers } from '../phase';

export const supplementaryConstants = {
    status: SUPPLEMENTARY_BUDGET_STATUS,
    inProgressStatus: BUDGET_LINE_STATUS_TODO,
    toValidateStatus: BUDGET_LINE_STATUS_TO_ARBITRATE,
    doneStatus: BUDGET_LINE_STATUS_ARBITRATED,
    comment: SUPPLEMENTARY_BUDGET_COMMENT,
    amount: SUPPLEMENTARY_BUDGET_AMOUNT,
    id: SUPPLEMENTARY_BUDGET_ID,
    table: SUPPLEMENTARY_BUDGET,
    endpoint: SUPPLEMENTARY_BUDGET_ENDPOINT,
    name: BudgetPhases.SUPPLEMENTARY_BUDGET,
    isEditable: true,
    isActive: true,
    isSimulated: false,
} as const;

const supplementaryHelpers: PhaseHelpers = {
    isInscriptionRejected: (
        inscription: InscriptionT,
        statusesSettings: StatusesSettingsT,
    ) =>
        isInscriptionRejectedForSupplementary(
            inscription,
            supplementaryConstants.status,
            BudgetPhases.SUPPLEMENTARY_BUDGET,
            statusesSettings,
        ),
    getPhaseHeaderName: (exercice, t) =>
        t
            ? t('budgetProposal.supplementaryBudgetYear', {
                  year: exercice,
              })
            : '',
} as const;

export const supplementaryPhase = {
    ...supplementaryConstants,
    ...supplementaryHelpers,
} as const;
